import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, BackHandler } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";

export default function NoInternetScreen({ onRetry }: any) {

  const closeApp = () => {
    BackHandler.exitApp();
  };

  return (
    <View style={styles.container}>

      <Icon name="wifi-off" size={90} color="#f97316" />

      <Text style={styles.title}>No Internet Connection</Text>

      <Text style={styles.desc}>
        Please check your internet connection and try again.
      </Text>

      <View style={styles.buttons}>

        <TouchableOpacity style={styles.retryBtn} onPress={onRetry}>
          <Text style={styles.btnText}>Retry</Text>
        </TouchableOpacity>

        <TouchableOpacity style={styles.cancelBtn} onPress={closeApp}>
          <Text style={styles.btnText}>Cancel</Text>
        </TouchableOpacity>

      </View>

    </View>
  );
}

const styles = StyleSheet.create({

  container:{
    flex:1,
    justifyContent:"center",
    alignItems:"center",
    padding:30,
    backgroundColor:"#fff"
  },

  title:{
    fontSize:22,
    fontWeight:"bold",
    marginTop:15
  },

  desc:{
    textAlign:"center",
    marginTop:10,
    color:"#666"
  },

  buttons:{
    flexDirection:"row",
    marginTop:25,
    gap:10
  },

  retryBtn:{
    backgroundColor:"#f97316",
    paddingVertical:10,
    paddingHorizontal:25,
    borderRadius:8
  },

  cancelBtn:{
    backgroundColor:"#999",
    paddingVertical:10,
    paddingHorizontal:25,
    borderRadius:8
  },

  btnText:{
    color:"#fff",
    fontWeight:"bold"
  }

});